export function CalculationTableRow({ title, helpText, children }) {
	return <div className="calc-row">
		<h3>{title}</h3>
		<div className="calc-row-content">{children}</div>

		{helpText && <p className='remark'>{helpText}</p>}
	</div>;
}
